import { Box, ModalCloseButton, ModalHeader } from '@chakra-ui/react'
import React from 'react'

interface EventModalHeaderProps {
  children: React.ReactNode
  showCloseButton?: boolean
  onClose?: () => void
  [key: string]: any
}

export const EventModalHeader: React.FC<EventModalHeaderProps> = ({
  children,
  showCloseButton,
  onClose,
  ...additionalProps
}) => {
  return (
    <ModalHeader
      fontSize="18px"
      textAlign="center"
      p="24px 24px 0 24px"
      {...additionalProps}
    >
      {children}
      {showCloseButton && (
        <Box>
          <ModalCloseButton
            _focus={{ outline: 'none' }}
            top="20px"
            right="16px"
            onClick={onClose}
          />
        </Box>
      )}
    </ModalHeader>
  )
}
